import {Component, OnInit, EventEmitter, Output, Input, HostListener} from '@angular/core';
import { NgxLoopReportService } from '../ngx-loop-report/ngx-loop-report.service';
import { TranslateService } from '../translate.service';
import { TranslatePipe } from '../translate.pipe';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AutoReportsDialogComponent } from './auto-reports-dialog/auto-reports-dialog';

class Report{
    constructor(
        public id?:number,
        public title?:string,
        public favorite?:boolean,
        public type?:string,
        public icon?:string,
        public data?:string
    ){}
}

class Group{
    constructor(
        public id?:number,
        public name?:string,
        public icon?:string,
        public reports?:Report[],
        public expanded?:boolean
    ){}
}

@Component({
    selector: 'NgxLoopReportsList',
    templateUrl: './ngx-loop-reports-list.html',
    styleUrls: ['./ngx-loop-reports-list.css' ]
})

export class NgxLoopReportsListComponent implements OnInit {

    @Output('onReportClick') onReportClick:EventEmitter<Report> = new EventEmitter();
    @Input() basePath : string = 'reports'
    @Input() autoReportIcon:string = 'mdi-cogs';
    hoveredElement:HTMLElement = null;

    loading:boolean = false;
    all_groups:Group[] = [];
    groups:Group[] = [];
    favorites:Group;

    @HostListener('window:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if(event.ctrlKey || event.metaKey){
            if(this.hoveredElement != null){
                this.hoveredElement.classList.add("willOpenBlank");
            }
        }
    }

    @HostListener('window:keyup', ['$event'])
    handleKeyboardUpEvent(event: KeyboardEvent) {
        if(event.metaKey || event.key == 'Control' || event.key == 'Meta'){
            if(this.hoveredElement != null){
                this.hoveredElement.classList.remove("willOpenBlank");
            }
        }
    }

    constructor(
        private dialog:MatDialog,
        private reportService: NgxLoopReportService,
        private translate: TranslateService,
        private translatePipe: TranslatePipe,
        private router: Router
    ){
        this.favorites = new Group(null, "label.favorites","star",[],true);
    }

    ngOnInit() {
        this.downloadUserReports();
    }

    onmouseover(event){
        let target = event.target;
        if(!target.hasAttribute("show-pro") || target.getAttribute("show-pro") == "false"){
            this.hoveredElement = target;
            if(event.ctrlKey)
                this.hoveredElement.classList.add("willOpenBlank");
            else
                this.hoveredElement.classList.remove("willOpenBlank");
        }
    }

    onmouseout(event){
        let target = event.target;
        target.classList.remove("willOpenBlank");
        this.hoveredElement = null;
    }

    public filterReports(event){
        let text:string = (event.target)?event.target.value:event.data;
        this.groups = this.all_groups.filter((group:Group) => {
            return group.reports.some((report:Report) => this.textIsContained(report, text, ['title']));
        }).map((group:Group) => {
            let newGroup:Group = Object.create(group);
            if(text.trim() != "")
                newGroup.expanded = true;
            return newGroup;
        })
        this.groups.forEach((group) => {
            group.reports = group.reports.filter( (report:Report) => {
                return this.textIsContained(report, text, ['title']);
            });
        });

    }

    private replaceAcents(text){
        text = text.replace(/[Ã¡Ã Ã£Ã¢Ã¤]/gi,"a")
            .replace(/[Ã©Ã¨Â¨Ãª]/gi,"e")
            .replace(/[Ã­Ã¬Ã¯Ã®]/gi,"i")
            .replace(/[Ã³Ã²Ã¶Ã´Ãµ]/gi,"o")
            .replace(/[ÃºÃ¹Ã¼Ã»]/gi, "u")
            .replace(/[Ã§]/gi, "c")
            .replace(/[Ã±]/gi, "n")
            .replace(/[^a-zA-Z0-9]/g," ");
        console.log(text);
        return text;
    }

      private textIsContained(resource:any, text:string, attributes):boolean{
        let contains = false;
        for(let attr of attributes){
          if(resource[attr] != null && text != null){
            text = this.replaceAcents(text.toLowerCase());
            let report = this.translatePipe.transform(resource[attr]);
            report = this.replaceAcents(report.toLowerCase());
            if(report.includes(text)){
              contains = true;
              break;
            }
          }
        }
        return contains;
      }

    private downloadUserReports(){
        this.loading = true;
        this.reportService.getUserReports().then((items) => {
            let groups = {};
            groups[this.favorites.name] = this.favorites;

            for(let item of items){
                if(item != null){
                    item["FAVORITE"] = (item["FAVORITE"])?true:false;
                    let report =  new Report(
                        item["ID"],
                        item["TITLE"],
                        item["FAVORITE"],
                        item["TYPE"],
                        item["ICON"],
                        item["DATA"]
                    );
                    if(groups[item["GROUP_NAME"]] == null){
                        groups[item["GROUP_NAME"]] = new Group(
                            item["ID_GROUP"],
                            item["GROUP_NAME"],
                            item["GROUP_ICON"],
                            [],
                            false
                        );
                    }
                    groups[item["GROUP_NAME"]].reports.push(report);
                    if(item["FAVORITE"]) this.favorites.reports.push(report);
                }
            };
            this.all_groups = Object.values(groups);
            this.groups = this.all_groups;
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            this.loading = false;
        });
    }

    public onReportClicked(event, report){
        event.stopPropagation();
        if (report.type == "sql")
            this.router.navigate([this.basePath,'form'], {queryParams:{'id_report':report.id}});
        else if(report.type == "link")
            this.router.navigate([report.data]);
        else if(report.type == "auto_reports")
            this.openAutoReportsDialog(report);
        else if(report.type == "jsreport")
            this.router.navigate([this.basePath, 'form2'], {queryParams:{'id_report':report.id}});
    }

    public setReportFavorite(event,report:Report){
        event.stopPropagation();

        this.loading = true;
        let index = null;
        let action = (report.favorite)?'remove':'add';
        if(action == 'remove'){
            index = this.favorites.reports.indexOf(report);
            this.favorites.reports.splice(index,1);
        }else{
            this.favorites.reports.push(report);
        }
        report.favorite = !report.favorite;
        this.reportService.setReportFavorite(report.id, report.favorite).catch((error) => {
            report.favorite = !report.favorite;
            if(action == 'remove'){
                this.favorites.reports.splice(index, 0, report);
            }else{
                this.favorites.reports.splice(this.favorites.reports.indexOf(report),1);
            }
        }).finally(() => {
            this.loading = false;
        });
    }

    private openAutoReportsDialog(report){
        this.dialog.open(AutoReportsDialogComponent,{
            maxWidth:'500px',
            width: '500px',
            data:report,
            panelClass:'dialog'
        });
    }

}
